import * as yup from 'yup'

export const int64 = yup
    .number()
    .min(-9223372036854775808)
    .max(9223372036854775807)

export const getLabel = (name: string) => {
  const label =
    name.match(/[A-Z]?[a-z]+|[0-9]+|[A-Z]+(?![a-z])/g) || name.split('_')

  if (label.includes('mt') && label.includes('4')) {
    return label.join(' ').replace('mt 4', 'MT4')
  }
  if (label.includes('MT') && label.includes('4')) {
    return label.join(' ').replace('MT 4', 'MT4')
  }
  if (label.includes('mt') && label.includes('5')) {
    return label.join(' ').replace('mt 5', 'MT5')
  }
  if (label.includes('MT') && label.includes('5')) {
    return label.join(' ').replace('MT 5', 'MT5')
  }

  return label.join(' ')
}

export function isValidEmptyValue(val: any): boolean {
  return val === '' || val == null || val === 'null'
}
